/* tslint:disable */
/* eslint-disable */
/**
 * HashiCorp Cloud Platform Vagrant Box Registry
 * API for managing Vagrant boxes.
 *
 * The version of the OpenAPI document: 2022-09-30
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { HashicorpCloudVagrant20220930CreateRegistryRequestToJSON, HashicorpCloudVagrant20220930CreateRegistryResponseFromJSON, HashicorpCloudVagrant20220930ListRegistriesResponseFromJSON, HashicorpCloudVagrant20220930ReadRegistryResponseFromJSON, } from '../models';
/**
 *
 */
export class RegistryServiceApi extends runtime.BaseAPI {
    /**
     * Activation will re-enable a Registry, allowing requests and accruing charges as normal.
     * ActivateRegistry activates a Vagrant Box Registry at the Location specified. The Registry must already exist and must be currently disabled.
     */
    async activateRegistryRaw(requestParameters) {
        if (requestParameters.registry === null || requestParameters.registry === undefined) {
            throw new runtime.RequiredError('registry', 'Required parameter requestParameters.registry was null or undefined when calling activateRegistry.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling activateRegistry.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/vagrant/2022-09-30/registry/{registry}/activate`.replace(`{${"registry"}}`, encodeURIComponent(String(requestParameters.registry))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Activation will re-enable a Registry, allowing requests and accruing charges as normal.
     * ActivateRegistry activates a Vagrant Box Registry at the Location specified. The Registry must already exist and must be currently disabled.
     */
    async activateRegistry(registry, body) {
        const response = await this.activateRegistryRaw({ registry: registry, body: body });
        return await response.value();
    }
    /**
     * CreateRegistry creates a Vagrant Box Registry at the Location specified.
     */
    async createRegistryRaw(requestParameters) {
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createRegistry.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/vagrant/2022-09-30/registry`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudVagrant20220930CreateRegistryRequestToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVagrant20220930CreateRegistryResponseFromJSON(jsonValue));
    }
    /**
     * CreateRegistry creates a Vagrant Box Registry at the Location specified.
     */
    async createRegistry(body) {
        const response = await this.createRegistryRaw({ body: body });
        return await response.value();
    }
    /**
     * Deactivation will disable a Registry but not delete its data. All requests to the Registry will return not-found errors. This can be used to temporarily block access to a Registry to prevent access-related charges to the Registry.
     * DeactivateRegistry deactivates a Vagrant Box Registry at the Location specified. The Registry must already exist and must be currently enabled.
     */
    async deactivateRegistryRaw(requestParameters) {
        if (requestParameters.registry === null || requestParameters.registry === undefined) {
            throw new runtime.RequiredError('registry', 'Required parameter requestParameters.registry was null or undefined when calling deactivateRegistry.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling deactivateRegistry.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/vagrant/2022-09-30/registry/{registry}/deactivate`.replace(`{${"registry"}}`, encodeURIComponent(String(requestParameters.registry))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Deactivation will disable a Registry but not delete its data. All requests to the Registry will return not-found errors. This can be used to temporarily block access to a Registry to prevent access-related charges to the Registry.
     * DeactivateRegistry deactivates a Vagrant Box Registry at the Location specified. The Registry must already exist and must be currently enabled.
     */
    async deactivateRegistry(registry, body) {
        const response = await this.deactivateRegistryRaw({ registry: registry, body: body });
        return await response.value();
    }
    /**
     * Deletion removes the Registry and all of its Box, Version, and Provider data, including any Hosted Providers and their respective data. This operation is permanent and cannot be undone.
     * DeleteRegistry deletes a Vagrant Box Registry at the Location specified.
     */
    async deleteRegistryRaw(requestParameters) {
        if (requestParameters.registry === null || requestParameters.registry === undefined) {
            throw new runtime.RequiredError('registry', 'Required parameter requestParameters.registry was null or undefined when calling deleteRegistry.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/vagrant/2022-09-30/registry/{registry}`.replace(`{${"registry"}}`, encodeURIComponent(String(requestParameters.registry))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Deletion removes the Registry and all of its Box, Version, and Provider data, including any Hosted Providers and their respective data. This operation is permanent and cannot be undone.
     * DeleteRegistry deletes a Vagrant Box Registry at the Location specified.
     */
    async deleteRegistry(registry) {
        const response = await this.deleteRegistryRaw({ registry: registry });
        return await response.value();
    }
    /**
     * ListRegistries lists available Vagrant Box Registries in a particular Project.
     */
    async listRegistriesRaw(requestParameters) {
        const queryParameters = {};
        if (requestParameters.locationOrganizationId !== undefined) {
            queryParameters['location.organization_id'] = requestParameters.locationOrganizationId;
        }
        if (requestParameters.locationProjectId !== undefined) {
            queryParameters['location.project_id'] = requestParameters.locationProjectId;
        }
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/vagrant/2022-09-30/registry`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVagrant20220930ListRegistriesResponseFromJSON(jsonValue));
    }
    /**
     * ListRegistries lists available Vagrant Box Registries in a particular Project.
     */
    async listRegistries(locationOrganizationId, locationProjectId, locationRegionProvider, locationRegionRegion, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.listRegistriesRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, locationRegionProvider: locationRegionProvider, locationRegionRegion: locationRegionRegion, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     * ReadRegistry reads a Vagrant Box Registry by its name.
     */
    async readRegistryRaw(requestParameters) {
        if (requestParameters.registry === null || requestParameters.registry === undefined) {
            throw new runtime.RequiredError('registry', 'Required parameter requestParameters.registry was null or undefined when calling readRegistry.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/vagrant/2022-09-30/registry/{registry}`.replace(`{${"registry"}}`, encodeURIComponent(String(requestParameters.registry))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVagrant20220930ReadRegistryResponseFromJSON(jsonValue));
    }
    /**
     * ReadRegistry reads a Vagrant Box Registry by its name.
     */
    async readRegistry(registry) {
        const response = await this.readRegistryRaw({ registry: registry });
        return await response.value();
    }
}
